var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdaSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 147.03001 100.58999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3720"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style3718"
  }, ".cls-1{fill:#373737;}.cls-2{fill:#005941;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title3722"
  }, "usda-symbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title3722"
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 33.35,4.09 33.16,29.45 C 33.16,40 26.9,44.08 18.49,44.08 11.24,44.08 2,40.86 2,29.88 V 4.09 A 3.15,3.15 0 0 0 0,1.3 H 11.89 A 3.09,3.09 0 0 0 9.97,4.09 v 26 c 0,4.34 1.49,10.48 9.55,10.48 7.38,0 10,-4.84 10,-11 L 29.44,4.09 A 3,3 0 0 0 27.77,1.3 h 7.19 a 3,3 0 0 0 -1.61,2.79 z",
    id: "path3724",
    style: {
      fill: "#373737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 50.14,44.08 a 26.32,26.32 0 0 1 -11.9,-3 L 37.93,30.6 c 1.18,4.4 4.9,10.23 11.35,10.23 6.14,0 8,-4.4 8,-7.44 0,-6 -5.39,-6.76 -11,-9.8 C 40.67,20.55 38.1,17.08 38.1,12.37 38.05,4 45.93,0.62 51.57,0.62 a 20,20 0 0 1 9.36,2.29 l 0.31,9.18 C 60.37,8.8 56.84,3.84 50.89,3.84 c -4.71,0 -6.57,3.29 -6.57,6 0,3.78 2.67,5.21 8.49,7.87 5.82,2.66 11.78,4.73 11.78,13.35 0,7.75 -6.82,13.02 -14.45,13.02 z",
    id: "path3726",
    style: {
      fill: "#373737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 84.61,43.46 H 68.68 a 3.08,3.08 0 0 0 1.61,-2.79 V 4.09 A 3,3 0 0 0 68.68,1.3 h 16.49 c 20.4,0 24.49,14.45 24.49,20.46 0,10.79 -8.31,21.7 -25.05,21.7 z M 83.87,4.4 c -1.49,0 -4.77,0 -5.7,0.12 v 35.72 h 5 c 14,0 17.92,-9.42 17.92,-18.48 C 101.04,14.32 96.7,4.4 83.87,4.4 Z",
    id: "path3728",
    style: {
      fill: "#373737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 133.76,43.46 c 1.61,-0.87 1.92,-1.74 1.49,-3 -0.19,-0.62 -1.8,-4.4 -3.53,-8.62 h -15.23 a 91.26,91.26 0 0 0 -3.47,8.56 c -0.56,1.49 -0.25,2.36 1.43,3.1 h -8.56 a 7.36,7.36 0 0 0 2.91,-3 C 110.02,38.07 126.32,0 126.32,0 c 0,0 16.49,38.07 17.61,40.42 a 5.46,5.46 0 0 0 3.1,3 z m -9.8,-30.07 c 0,0 -4.22,10.54 -6.2,15.19 h 12.53 c -2.91,-6.88 -6.32,-15.19 -6.32,-15.19 z",
    id: "path3730",
    style: {
      fill: "#373737"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 145.17,49.42 c 0,0 -90.23,-2.24 -143.68,26.24 0,0 56.63,-22.4 143.66,-20.16 z",
    id: "path3732",
    style: {
      fill: "#575757"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1.49,49.42 c 0,0 30.39,0.32 49.27,7.36 0,0 -38.71,-3.2 -49.27,-1.6 z",
    id: "path3734",
    style: {
      fill: "#575757"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 1.49,59.34 c 0,0 21.76,-1 34.87,0.32 0,0 -31.67,3.84 -34.87,5.44 z",
    id: "path3736",
    style: {
      fill: "#575757"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m 130.22,60.32 h -0.46 C 103.49,60.83 48.49,64 1.49,80.59 v 20 H 145.15 V 60.32 c 0,0 -5.54,-0.17 -14.93,0 z",
    id: "path3738",
    style: {
      fill: "#575757"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdaSymbol);
export default __webpack_public_path__ + "static/media/usda-symbol.dee144f48fdd02f5bcb978616b444981.svg";
export { ForwardRef as ReactComponent };